<template>
  <div>
    <span v-if="isLoadding" style="height: 100px">
      <v-container
        fill-height
        fluid
        :style="
          display === 'Desktop'
            ? 'height: ' + (heightDisplay - 325) + 'px;'
            : 'height: ' + (heightDisplay - 150) + 'px;'
        "
      >
        <v-row align="center" justify="center">
          <v-col
            lg="12"
            sm="12"
            md="12"
            cols="12"
            xl="12"
            xs="12"
            class="text-center"
            ><h1 style="font-size: 48px">
              <span style="color: #3f44a3">Kan</span>
              <span style="color: #4a98b2">Pramool</span>
            </h1>
          </v-col>
          <v-col
            class="text-center"
            sm="10"
            md="6"
            cols="8"
            xl="3"
            xs="10"
            lg="3"
            ><v-progress-linear
              color="#F8F364"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear
          ></v-col>
        </v-row>
      </v-container>
    </span>

    <v-row>
      <v-dialog v-model="dialoginvite" persistent max-width="80%">
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            style="font-family: 'Kanit', sans-serif"
            >แก้ไขข้อมูลรหัสโครงการเลขที่ : {{ form.project_code }}
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="7" md="7" class="Format">
                  <v-textarea
                    rows="4"
                    row-height="30"
                    outlined
                    label="ชื่อโครงการ(เรื่อง)"
                    v-model="form.project_name"
                    dense
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="5" md="5">
                  <v-text-field
                    dense
                    label="ชื่อย่อโครงการ"
                    type="text"
                    v-model="form.short_project_name"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="ชื่อหน่วยงาน"
                    type="text"
                    dense
                    v-model="form.institution"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="4" class="Format">
                  <v-autocomplete
                    v-model="form.province"
                    item-text="name_th"
                    item-value="id"
                    @input="getamphures()"
                    outlined
                    dense
                    label="จังหวัด"
                    :items="provinceAll"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete
                    v-model="form.amphures"
                    @input="getdistricts()"
                    :items="amphuress"
                    item-text="name_th"
                    item-value="id"
                    outlined
                    dense
                    label="อำเภอ"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete
                    v-model="form.districts"
                    :items="districtss"
                    item-text="name_th"
                    item-value="id"
                    outlined
                    dense
                    label="ตำบล"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" class="Format">
                  <v-autocomplete
                    v-model="form.genus_typ_id"
                    item-text="genus_typ_name"
                    item-value="genus_typ_id"
                    outlined
                    dense
                    label="ประเภทการจัดหา"
                    :items="torGenusTyp"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="Format">
                  <v-autocomplete
                    v-model="form.type_of_work"
                    :items="typeOfWork"
                    item-text="job_type_name"
                    item-value="job_type_id"
                    hide-details="auto"
                    outlined
                    dense
                    chips
                    small-chips
                    label="ประเภทงาน"
                    multiple
                  >
                    <template v-slot:selection="data">
                      <v-chip close small class="chip--select-multi">
                        {{ data.item.job_type_name }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content
                          v-text="data.item.job_type_name"
                        ></v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="2" md="2" class="Format">
                  <v-text-field
                    label="ตำเเหน่งหน้างานlatitude"
                    type="text"
                    dense
                    v-model="form.latitude"
                    outlined
                    @input="changeInduce()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" md="2" class="Format">
                  <v-text-field
                    label="ตำเเหน่งหน้างานlongitude"
                    v-model="form.longitude"
                    outlined
                    dense
                    @input="changeMiddle()"
                    target="#dropdown-example-2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <v-autocomplete
                    v-model="form.tor_status_id"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    label="สถานะโครงการ"
                    :items="torStatus"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" class="Format">
                  <v-text-field
                    label="งบประมาณโครงการ"
                    type="text"
                    dense
                    v-model="form.expenditure"
                    outlined
                  >
                    <span slot="append">บาท</span></v-text-field
                  >
                </v-col>
                <v-col cols="12" sm="3" md="3" class="Format">
                  <v-text-field
                    label="ราคากลาง"
                    v-model="form.middle_price"
                    outlined
                    dense
                    @input="changeMiddle()"
                    target="#dropdown-example-2"
                    ><span slot="append">บาท</span></v-text-field
                  >
                </v-col>
                <v-col cols="12" sm="3" md="3" class="Format">
                  <v-text-field
                    label="มูลค่าผลงานประเภทเดียวกัน"
                    v-model="form.same_price"
                    outlined
                    dense
                    @input="changeSame()"
                    target="#dropdown-example-2"
                    ><span slot="append">บาท</span></v-text-field
                  >
                </v-col>
                <v-col cols="12" sm="3" md="3" class="Format">
                  <v-text-field
                    dense
                    @input="changeSecret()"
                    label="ราคาซอง"
                    v-model="form.secret_price"
                    outlined
                    target="#dropdown-example-2"
                    ><span slot="append">บาท</span></v-text-field
                  >
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  sm="3"
                  md="3"
                  class="Format"
                  style="
                    padding-top: 0px;
                    padding-right: 0px;
                    padding-left: 0px;
                  "
                >
                  <v-card-text>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      :return-value.sync="form.induceDateStart"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="วันที่เสนอราคา"
                          readonly
                          placeholder="คลิกเพื่อเลือก"
                          v-model="form.induceDateStart"
                          hide-details="auto"
                          v-bind="attrs"
                          v-on="on"
                          @input="changeDate()"
                          outlined
                          dense
                          target="#dropdown-example-2"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="form.induceDateStart"
                        scrollable
                        locale="th-TH"
                        color="green lighten-1"
                        @input="$refs.menu.save(form.induceDateStart)"
                      ></v-date-picker>
                    </v-menu>
                  </v-card-text>
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  md="3"
                  class="Format"
                  style="
                    padding-top: 0px;
                    padding-right: 0px;
                    padding-left: 0px;
                  "
                >
                  <v-card-text>
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      :return-value.sync="form.submissionDate"
                      min-width="290px"
                      style="padding-top: 0px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="วันที่ยื่นเสนอราคา"
                          readonly
                          placeholder="คลิกเพื่อเลือก"
                          v-model="form.submissionDate"
                          hide-details="auto"
                          v-bind="attrs"
                          v-on="on"
                          @input="changeDate()"
                          outlined
                          dense
                          target="#dropdown-example-2"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="form.submissionDate"
                        scrollable
                        locale="th-TH"
                        color="green lighten-1"
                        @input="$refs.menu1.save(form.submissionDate)"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-card-text>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="Format">
                  <v-text-field
                    dense
                    label="คุณสมบัติพิเศษ"
                    v-model="form.special_features"
                    outlined
                    target="#dropdown-example-2"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="2" md="2" class="Format">
                  <v-text-field
                    label="เบอร์โทรหน่วยงาน"
                    dense
                    @input="changeTel()"
                    type="text"
                    v-model="form.institution_tall"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" @click="update()">
              <v-icon light style="color: #fff"
                >mdi-content-save-outline</v-icon
              >
              <span style="color: #fff">อัพเดทข้อมูล</span>
            </v-btn>
            <v-btn color="red" @click="cancelScreen()">
              <v-icon light style="color: #fff">mdi-close-octagon</v-icon>
              <span style="color: #fff">ปิดหน้าจอ</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col
        v-if="!isLoadding"
        cols="12"
        sm="11"
        md="11"
        style="padding-top: 80px; padding-left: 10%"
      >
        <v-card>
          <v-card-title>
            ประกาศเชิญชวน
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="ค้นหาข้อมูล"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            style="padding-bottom: 50px"
            :headers="headers"
            :items="torProject"
            :search="search"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template v-slot:[`item.expenditure`]="{ item }">
              {{
                item.expenditure
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      menu1: null,
      menu: null,
      modal: true,
      moment: true,
      typeOfWork: [],
      input_file: null,
      dialoginvite: false,
      provinceAll: null,
      display: false,
      heightDisplay: null,
      search: "",
      torGenusTyp: [],
      torStatus: [],
      amphuress: [],
      districtss: [],
      isLoadding: false,
      form: {
        point_staff: 1,
        short_project_name: null,
        induceDateStart: "",
        submissionDate: "",
        tor_status_id: null,
        type: "invite",
        project_code: "",
        induce_date_start: "",
        project_name: "",
        institution: "",
        institution_tall: "",
        name_th: "",
        genus_typ: "",
        submission_date: "",
        job_type_name: "",
        province: null, //จังหวัด
        amphures: null,
        districts: null,
        type_of_work: "",
        expenditure: "",
        middle_price: "",
        same_price: "",
        secret_price: "",
        special_features: "",
        latitude: "",
        longitude: "",
        created_datetime: "",
        row: localStorage.getItem("role"),
        created_by: localStorage.getItem("username"), //เพิ่มโดย
        created_by_notify: localStorage.getItem("fullname"),
      },
      headers: [
        { text: "รหัสโครงการ", value: "project_code" },
        { text: "ชื่อโครงการ", value: "project_name", width: "45%" },
        {
          text: "หน่วยงาน",
          align: "start",
          sortable: false,
          value: "institution",
        },
        { text: "งบประมาณ", value: "expenditure" },
        { text: "จังหวัด", value: "name_th" },
        { text: "วันที่ประกาศ", value: "induceStart" },
        { text: "ชื่อพนักงานคีย์", value: "created_by" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      torProject: [],
    };
  },
  mounted() {
    if (localStorage.getItem("username") === null) {
      alert("กรุณาลงชื่อเข้าสู่ระบบก่อน");
      this.$router.push("/login");
    } else {
      this.checkHightDisplay();
      this.isLoadding = true;
      axios.get(this.api + "/get/tor_status").then((res) => {
        this.torStatus = [];
        this.torStatus = res.data.response;
        axios.get(this.api + "/all/province").then((res) => {
          this.provinceAll = [];
          this.provinceAll = res.data.response;
          axios.get(this.api + "/get/tor_genus_typ").then((res) => {
            this.torGenusTyp = [];
            this.torGenusTyp = res.data.response;
            axios.get(this.api + "/get/ebiiding_jobtype").then((res) => {
              this.typeOfWork = [];
              this.typeOfWork = res.data.response;
              if (localStorage.getItem("role") === "Admin") {
                axios.get(this.api + "/get/tor_project_invite").then((res) => {
                  this.isLoadding = false;
                  this.torProject = [];
                  this.torProject = res.data.response;
                  if (res.data.status) {
                    this.moment = false;
                  } else {
                    alert("เกิดความผิดพลาดในการแสดงข้อมูล");
                  }
                });
              } else {
                axios
                  .post(this.api + "/get/tor_project_invite/Operation", {
                    created_at: localStorage.getItem("username"),
                  })
                  .then((res) => {
                    this.isLoadding = false;
                    this.torProject = [];
                    this.torProject = res.data.response;
                    if (res.data.status) {
                      this.moment = false;
                    } else {
                      alert("เกิดความผิดพลาดในการแสดงข้อมูล");
                    }
                  });
              }
            });
          });
        });
      });
    }
  },
  methods: {
    checkHightDisplay() {
      this.heightDisplay = screen.height;
    },
    getamphures() {
      if (this.form.province != null) {
        this.isLoadding = true;
        axios
          .post(this.api + "/get/amphures", { province: this.form.province })
          .then((res) => {
            this.isLoadding = false;
            this.amphuress = res.data.response;
          });
      } else {
        alert("กรุณาเลือกจังหวัด");
      }
    },
    getdistricts() {
      if (this.form.amphures != null) {
        this.isLoadding = true;
        axios
          .post(this.api + "/get/districts", { amphure: this.form.amphures })
          .then((res) => {
            this.isLoadding = false;
            this.districtss = res.data.response;
          });
      } else {
        alert("กรุณาเลือกอำเภอ");
      }
    },
    cancelScreen() {
      this.dialoginvite = false;
    },
    editItem(item) {
      this.form.short_project_name = item.short_project_name;
      this.form.submissionDate = item.submissionDate;
      this.form.induceDateStart = item.induceDateStart;
      this.form.districts = item.tambon;
      this.form.tor_status_id = item.tor_status_id;
      this.form.project_code = item.project_code;
      this.form.institution = item.institution;
      this.form.institution_tall = item.institution_tall;
      this.form.project_name = item.project_name;
      this.form.tor_date_start = item.tor_date_start;
      this.form.tor_date_end = item.tor_date_end;
      this.form.expenditure = item.expenditure;
      this.form.province = item.province;
      this.form.genus_typ_id = parseInt(item.genus_typ_id);
      this.form.amphures = parseInt(item.amphoe);
      // this.form.type_of_work = item.type_of_work;
      this.form.middle_price = item.middle_price;
      this.form.submission_date = item.submission_date;
      this.form.induce_date_start = item.induce_date_start;
      this.form.job_type_name = item.job_type_name;
      this.form.type_of_work = item.type_of_work_id
        .replace(/'/g, "")
        .split(",");
      this.form.same_price = item.same_price;
      this.form.secret_price = item.secret_price;
      this.form.special_features = item.special_features;
      this.form.latitude = item.latitude;
      this.form.longitude = item.longitude;

      if (this.form.province !== null) {
        this.getamphures();
      }
      if (this.form.amphures !== null) {
        this.getdistricts();
      }
      this.dialoginvite = true;
    },
    update() {
      this.isLoadding = true
      if (this.form.row === "Admin") {
        this.form.point_staff = -1;
      }
      axios
        .post(this.api + "/update/tor_project_induce", this.form)
        .then((res) => {
            this.isLoadding = false
          if (res.data.status) {
            location.reload();
          } else {
            alert("บันทึกข้อมูลผิดพลาด");
          }
        });
      this.dialog = false;
    },

    fileToBase64() {
      let reader = new FileReader();
      reader.readAsDataURL(this.input_file);
      reader.onload = () => {
        this.form.file_base64 = reader.result;
      };
    },
    changeInduce() {
      this.form.induce_date_start = this.form.induce_date_start
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/ตุลาคม/g, "10")
        .replace(/ธันวาคม/g, "12")
        .replace(/พฤศจิกายน/g, "11")
        .replace(/กันยายน/g, "09")
        .replace(/สิงหาคม/g, "08")
        .replace(/กรกฎาคม/g, "07")
        .replace(/มิถุนายน/g, "06")
        .replace(/พฤษภาคม/g, "05")
        .replace(/เมษายน/g, "04")
        .replace(/มีนาคม/g, "03")
        .replace(/กุมภาพันธ์/g, "02")
        .replace(/มกราคม/g, "01")
        .trim();
    },
    changeMiddle() {
      this.form.middle_price = this.form.middle_price
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    changeSecret() {
      this.form.secret_price = this.form.secret_price
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    changeTel() {
      this.form.institution_tall = this.form.institution_tall
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .replace(/-/g, "")
        .trim();
    },
    changeSame() {
      this.form.same_price = this.form.same_price
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    changeDate() {
      this.form.submission_date = this.form.submission_date
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/ตุลาคม/g, "10")
        .replace(/ธันวาคม/g, "12")
        .replace(/พฤศจิกายน/g, "11")
        .replace(/กันยายน/g, "09")
        .replace(/สิงหาคม/g, "08")
        .replace(/กรกฎาคม/g, "07")
        .replace(/มิถุนายน/g, "06")
        .replace(/พฤษภาคม/g, "05")
        .replace(/เมษายน/g, "04")
        .replace(/มีนาคม/g, "03")
        .replace(/กุมภาพันธ์/g, "02")
        .replace(/มกราคม/g, "01")
        .replace(/ /g, "/")
        .trim();
    },
  },
};
</script>
